// <template>
//     <div class="coupon">
//         <hd title="商城说明"></hd>
//         <div class="coupon-box">
//             <div class="coupon-title">一、响币商城的由来</div>
//             <div class="coupon-content">
//                 <p>您每次使用响车车新能源汽车，都为这美丽的世界节能减排。为了感谢您为这世界作出的环保贡献，我们回馈响币于您，鼓励您使用我们新能源汽车，为全球变暖做出一份贡献。</p>
//             </div>
//         </div>
//         <div class="coupon-box">
//             <div class="coupon-title">二、兑换规则</div>
//             <ol class="coupon-content coupon-content1">
//                 <li>每次订单结算后，我们会根据您消费的金额进行等比例的回馈响币。消费1元对应获得1个响币。消费100元回馈100个响币。</li>
//                 <li>响币获得后，不可进行转赠。</li>
//                 <li>兑换规则最终解释权归响车车所有，兑换出现任何问题，请拨打客服热线400-863-7833进行咨询。</li>
//             </ol>
//         </div>
//
//     </div>
// </template>
// <script>
module.exports = {
    components: {
        'hd': require('c/near_powerstation/header.vue')
    }


    
}
// </script>
// <style lang="sass" scoped>
// .coupon{
//     width:100%;
//     min-height:100%;
//     padding:0.02rem 0.32rem 0.32rem;
//     box-sizing:border-box;
//     .coupon-box{
//         width:100%;
//         padding:0.32rem;
//         background-color:#fff;
//         box-sizing:border-box;
//         margin-top:0.213rem;
//         border-radius: 0.106rem;
//         box-shadow: 0px 0px 0px 0.02rem rgba(37,47,58,0.2);
//         .coupon-title{
//             font-size:.426667rem;
//             color: #252F3A;
//             font-weight: bold;
//         }
//         .coupon-content{
//             margin-top: 0.213rem;
//             box-sizing:border-box;
//             li,p{
//                 font-size: 0.373rem;
//                 color: #666D75;
//                 line-height:0.64rem;
//                 list-style: decimal;
//             }
//         }
//         .coupon-content1{
//             padding-left: 0.4rem;
//         }
//     }
// }
// </style>
//
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/shop_city.vue